import img1 from "../assets/gallery/Kashmir/Kashmir1.jpg";
import img2 from "../assets/gallery/Kashmir/Kashmir2.jpg";
import img3 from "../assets/gallery/Kashmir/Kashmir3.jpg";
import img4 from "../assets/gallery/Kashmir/Kashmir4.jpg";
import img5 from "../assets/gallery/Kashmir/Kashmir5.jpg";
import img6 from "../assets/gallery/Kashmir/Kashmir6.jpg";
import img7 from "../assets/gallery/Kashmir/Kashmir7.jpg";

const kashmirGallery = [
  { img: img1, rowSpan: 2 }, // tall left
  { img: img2 },
  { img: img3 },

  { img: img4, colSpan: 2 }, // wide image

  { img: img5 },
  { img: img6 },
  { img: img7 },
];

export default kashmirGallery;
